import React from 'react';
import styled from 'styled-components';

interface InformationProps {
	children?: string;
}

const Span = styled.span`
	line-height: 22px;
	font-size: 18px;
	color: gray;
`;

export function Information({ children = '' }: Readonly<InformationProps>) {
	return <Span>{children}</Span>;
}
